export interface ResolvedAutoReplyDraft {
	resolvedEnabled: boolean;
	resolvedFromName: string;
	resolvedFromEmail: string;
	resolvedBodyHtml: string;
}

export type ResolvedAutoReplyField = 'resolvedFromName' | 'resolvedFromEmail';

export interface ResolvedAutoReplyValidationError {
	field: ResolvedAutoReplyField;
	message: string;
}

// ACC-551: mirrors validateAutoReply for the resolved-trigger reply. From email is
// server-derived (read-only in the UI), so only the from name is validated, and
// only when the resolved reply is enabled.
export function validateResolvedAutoReply(draft: ResolvedAutoReplyDraft): ResolvedAutoReplyValidationError | null {
	if (!draft.resolvedEnabled) return null;

	if (draft.resolvedFromName.trim() === '') {
		return {field: 'resolvedFromName', message: 'From name is required'};
	}
	return null;
}

export function resolvedAutoReplyFieldError(
	error: ResolvedAutoReplyValidationError | null,
	field: ResolvedAutoReplyField
): string | null {
	if (!error || error.field !== field) return null;
	return error.message;
}
